import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  editor: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/editor.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/minimal.vue").then(m => m.default || m)),
  published: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/published.vue").then(m => m.default || m))
}